@if (user) {
    <nav
        class="sidebar bg-light d-flex flex-column pb-0"
        [ngStyle]="{ width: getSidebarWidth() }"
        [ngClass]="{ 'sidebar-mobile': isMobile }">
        @for (item of navigation; track item) {
            <ul class="nav nav-pills flex-column" [ngClass]="{ active: selectedItem === item || isActive(item.route) }">
                @if (displaySidebarItem(item)) {
                    <li #anchor>
                        <a
                            class="nav-section nav-link"
                            href="javascript:void(0)"
                            style="display: block"
                            (click)="selectItem(item)"
                            (mouseenter)="currentHover = item.title"
                            (mouseleave)="currentHover = null">
                            <div class="d-flex align-items-center">
                                @if (item.icon) {
                                    <fa-icon [icon]="item.icon"></fa-icon>
                                }
                                @if (!isCollapsed) {
                                    <span class="nav-title-padding">{{ item.title | translate }}</span>
                                }
                                @if (item.title === 'Approvals' && user?.pendingApprovals > 0) {
                                    <span class="badge badge-warning ml-1" [hidden]="isCollapsed">
                                        {{ user.pendingApprovals }}
                                    </span>
                                }
                                @if (item.title === 'Chat' && user.unreadChatCount > 0) {
                                    <span
                                        class="badge badge-danger ml-1"
                                        kendoTooltip
                                        title="{{ user.unreadChatCount }} {{ 'unread' | translate }}"
                                        [hidden]="isCollapsed">
                                        {{ user.unreadChatCount }}
                                    </span>
                                }
                                <span class="pull-right text-muted ml-auto" [hidden]="isCollapsed">
                                    <i
                                        class="fa fa-caret-down"
                                        [ngClass]="{
                                            'fa-caret-left': item === selectedItem,
                                            'fa-caret-down': item !== selectedItem
                                        }"></i>
                                </span>
                            </div>
                            <!-- Red pill for user.pendingApprovals -->
                        </a>
                        @if (currentHover && currentHover === item.title && isCollapsed) {
                            <kendo-popup [anchor]="anchor" [copyAnchorStyles]="true" [anchorAlign]="anchorAlign">
                                <div class="px-2 py-2 h-100">
                                    {{ item.title }}
                                </div>
                            </kendo-popup>
                        }
                        <ul class="nav nav-pills flex-column" [hidden]="isCollapsed || selectedItem !== item">
                            @for (child of item.childs; track child) {
                                @if (hasPermission(child)) {
                                    <li
                                        class="nav-item pl-0"
                                        [@openClose]="selectedItem ? 'open' : 'closed'"
                                        [ngClass]="{ active: isActive(child.route) }">
                                        <a
                                            class="nav-link d-flex align-items-center"
                                            routerLinkActive="active-router-link"
                                            (click)="changeRoute(child)">
                                            <span style="width: 20px">
                                                @if (child.icon) {
                                                    <fa-icon [icon]="child.icon"></fa-icon>
                                                }
                                            </span>
                                            @if (child.iconText) {
                                                <span class="textIcon">{{ child.iconText }}</span>
                                            }
                                            <span class="flex-grow-1">{{ child.title | translate }}</span>
                                            @if (child.type === 'email' || child.type === 'link') {
                                                <i class="fa fa-arrow-right ml-auto"></i>
                                            }
                                            <!-- Removed until we implement child unreadChatCount in table views
                      <span
                        *ngIf="child.unreadChatCount > 0"
                        class="badge badge-danger ml-2"
                        kendoTooltip
                        title="{{ child.unreadChatCount }} {{ 'unread chat messages' | translate }}">
                        <fa-icon [icon]="['fas', 'comment']"></fa-icon>
                        {{ child.unreadChatCount }}
                      </span> -->
                                        </a>
                                    </li>
                                }
                            }
                        </ul>
                    </li>
                }
            </ul>
        }
    </nav>
}
